<h1 mat-dialog-title>{{ "ENTER_MAIL_ADDRESS" | translated }}</h1>
<div mat-dialog-content>
  <mat-form-field>
    <input
      type="email"
      matInput
      [formControl]="emailFormControl"
      [errorStateMatcher]="matcher"
      placeholder="Ex. pat@example.com*"
    />
    <mat-error
      *ngIf="
        emailFormControl.hasError('email') &&
        !emailFormControl.hasError('required')
      "
    >
      {{ "INPUT_INVALID" | translated }}
    </mat-error>
  </mat-form-field>
</div>
<div mat-dialog-actions class="justify-content-around">
  <app-btn
    [dataTxt]="'BACK'"
    (callback)="back()"
  ></app-btn>
  <app-btn
    [dataTxt]="'NEXT'"
    [disabled]="!emailFormControl.valid"
    (callback)="submit()"
  ></app-btn>
</div>
